import type { IconComponentProps } from "..";

export function PicoIcon(props: IconComponentProps) {
	return (
		<svg
			{...props}
			fill="currentColor"
			role="img"
			viewBox="0 0 292.54 292.54"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>PICO</title>
			<path d="M153.05.16C72.35-3.58 3.9 58.8.16 139.48c-3.74 80.71 58.64 149.16 139.32 152.9 80.71 3.74 149.16-58.64 152.89-139.32C296.13 72.35 233.73 3.9 153.05.16Zm-1.73 37.24c60.12 2.8 106.62 53.81 103.82 113.93-.77 16.35-5.08 31.68-12.17 45.29-21.54-27.37-70.84-89.97-71.03-90.22-19.92-24.13-49.98-39.6-83.65-39.85-5.36 0-12.2.44-17.67 1.29 20.83-20.06 49.54-31.88 80.71-30.42v-.03l-.01.01Zm-10.11 217.75c-60.12-2.8-106.62-53.81-103.82-113.93.49-10.58 2.47-20.75 5.74-30.28.36-.27.58-.41.58-.41 31.99-23.52 77.11-17.56 101.84 13.85l77.87 98.87c-20.94 20.97-50.29 33.39-82.22 31.9h.01Z" />
			<path d="m87.38 163.14c9.33 0 16.899-7.57 16.899-16.9s-7.57-16.9-16.9-16.9-16.9 7.57-16.9 16.9 7.57 16.9 16.9 16.9" />
		</svg>
	);
}
